export class RecentFormResponsesModel {
  public category: string;

  constructor(data: IRecentFormResponsesModel) {
    if (!data) return null;

    let monthName = MONTH_SHORT_NAMES[new Date(data.submissionDate).getMonth()];
    let year = new Date(data.submissionDate).getFullYear();

    this.category = `${monthName} ${year}`;
  }
}

interface IRecentFormResponsesModel {
  submissionDate: Date;
}

export const MONTH_SHORT_NAMES = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];
